import { useMemo, useCallback, useEffect } from 'react'
import { Table, Col, Select, TreeSelect } from 'antd'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { getHtmlParentElement, renderTranslation } from '../../../Helpers/GenericHelpers'
import { SiteColumns, StoreColumns } from '../../../Constants/TableConfiguration'

import { useAppDispatch, useAppSelector } from '../../../hooks'

import { getStores } from 'Services/Omnichannel/StoresService'
import { convertDateToRomeTimeZone, isValidDate, localeSpecificDate } from 'Helpers/DateHelpers'
import dayjs from 'dayjs'
import { BaseStorePricelist, DateFormat } from 'Constants/Configuration'
import { setCapitalLetter } from 'Helpers/StringHelpers'

function Stores(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const stores = useAppSelector(state => state.present.store.stores)
  const listings = useAppSelector(state => state.present.configuration.allPricelists)
  useEffect(() => {
    dispatch(getStores())
  }, [dispatch, listings.length])

  const storeColumns = useMemo(() => {
    return Object.values(StoreColumns).map(x => {
      return {
        title: <div>{renderTranslation(language, TranslationKeys['storeTable' + setCapitalLetter(x)])}</div>,
        dataIndex: x,
        key: x,
        render: (text, record) => {
          switch (x) {
            case StoreColumns.SalesEndDate:
            case StoreColumns.SalesStartDate:
              if (text) {
                return dayjs(convertDateToRomeTimeZone(text)).format(DateFormat)
              } else return ''
            case StoreColumns.Pricelists:
              return text === BaseStorePricelist
                ? renderTranslation(language, TranslationKeys.pricelistBaseStore)
                : text

            default:
              return text
          }
        },
      }
    })
  }, [language])

  return (
    <Col span={24} className='site-setting-table-box mt-6'>
      <Table
        id='store-table'
        columns={storeColumns}
        rowKey={record => {
          return 'key-' + record.name
        }}
        dataSource={stores}
        pagination={false}
        tableLayout='fixed'
      />
    </Col>
  )
}

export default Stores
